<template>
    <div class="feed-media">
        <FeedImage v-for="(img, index) in imageList" :key="index" :imgUrl="img" :urlList="feed.uriKey"/>
    </div>
</template>
<script>
import FeedImage from '../feed-image';
export default {
    name: 'article-element',
    props: {
        feed: {
            type: Object,
            required: true
        },
        scene: String,
    },
    data() {
        return {
            imageList: []
        }
    },
    mounted() {
        if (this.feed.uriKey && this.feed.uriKey[0]) {
            if (this.scene=="feedDetail") {
                this.imageList = this.feed.uriKey
            } else {
                this.imageList = this.feed.uriKey.slice(0,3)
            }           
        }else {
            this.imageList = []
        }
    },
    components: {
        FeedImage,
    }
}
</script>
<style scoped>
.feed-media {
    width: 650px;
    display: flex;
    flex-wrap: wrap;
    margin: 8px 0;
}

.feed-media:empty {
    margin: 4px 0;
}
</style>